{
  "fr": {
    "validations": {
      "dialogFormat": "Veuillez indiquer les deux interlocuteurs avec **Nom** : au début de la ligne, suivi du texte parlé. Une ligne par intervention et pas d'autres **-marques dans le texte.",
      "email": "Veuillez saisir une adresse e-mail valide.",
      "embeddedAppNotFound": "Le contenu intégré n'a pas pu être trouvé.",
      "groupCountTooLarge": "Le nombre de groupes doit être inférieur au nombre de noms.",
      "groupSizeTooLarge": "Le nombre de membres par groupe doit être inférieur au nombre de noms.",
      "groupSizeTooSmall": "Le nombre de vos groupes dépasse le maximum de 20. Augmentez le nombre de membres par groupe ou réduisez le nombre de noms.",
      "integer": "Veuillez saisir un nombre entier.",
      "isYoutubeOrVimeoUrl": "Veuillez entrer une URL YouTube ou Vimeo valide.",
      "linkedAppNotFound": "Le contenu lié n'a pas pu être trouvé.",
      "maxLength": "Maximum {max} sélectionnable",
      "maxLengthValue": "La longueur maximale est de {max} caractères.",
      "minLength": "Au moins {min} lettres",
      "namesCountTooLarge": "Vous pouvez entrer un maximum de 100 noms.",
      "namesCountTooSmall": "Vous devez entrer au moins deux noms.",
      "required": "Ce champ est obligatoire.",
      "requiredIf": "Ce champ est obligatoire.",
      "tooManyWords": "Veuillez entrer un maximum de {count} mots.",
      "url": "Veuillez entrer une URL valide (incl. https://).",
      "validEmbedCode": "Veuillez saisir une URL valide ou un extrait de code iFrame.",
      "validUrl": "Veuillez saisir une URL valide.",
      "maxValue": "La valeur ne doit pas dépasser {max}.",
      "minValue": "La valeur doit être d'au moins {min}.",
      "youtubeOrVimeoUrl": "Veuillez entrer une URL YouTube ou Vimeo valide."
    }
  }
}
